<scope-ui-table
  *ngIf="mappedDepartmentsDataSource"
  [tableClass]="'overview-table'"
  [rowGaps]="true"
  [includeEmptyMessage]="false"
  [loggedInUser]="currentUser"
  [data]="mappedDepartmentsDataSource"
  [displayedColumns]="departmentColumns"
  [noSort]="true"
  [noPagination]="true"
  [showToggleMenu]="false"
  [deleteAction]="deleteDepartmentAction"
  [expandableNested]="true"
  [taskRolesTable]="true"
  [showExpandAll]="false"
  [useSourceId]="false"
  [stickyHeader]="true"
  [optimise]="false"
  [noPreferences]="true"
  [addToggleListColumn]="true"
  (tableExpandedChange)="tableExpandedChange.emit($event)">
</scope-ui-table>
